var _class, _descriptor, _TreatmentsSection;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { t } from 'ember-intl';
import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import 'ember-changeset';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import TreatmentPrescriptionChangedJournalEvent from 'core/models/treatment-prescription-changed-journal-event';
import Medication from 'core/models/prescriptions/medication';
import MedicationRequest from 'core/models/prescriptions/medication-request';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const ATC_TO_PRESCRIPTION = {
  B03X: {
    label: 'Traitement anti-anémique (hors fer, vitamine B12, folates)',
    cisCode: 'Traitement_anti_anemique'
  }
};
let TreatmentsSection = (_class = (_TreatmentsSection = class TreatmentsSection extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  addTreatment(code1, event1) {
    event1.preventDefault();
    const treatments1 = this.args.changeset.get('prescriptions') ? [...this.args.changeset.get('prescriptions')] : [];
    const prescriptionDetails1 = ATC_TO_PRESCRIPTION[code1];
    const medicationPayload1 = {
      cisCode: prescriptionDetails1.cisCode,
      brand: prescriptionDetails1.label,
      longDescription: prescriptionDetails1.label,
      shortDescription: prescriptionDetails1.label,
      state: 'D',
      uid: prescriptionDetails1.label,
      molecule: {
        code: code1,
        label: prescriptionDetails1.label
      }
    };
    const medication1 = new Medication(medicationPayload1);
    treatments1.push(new MedicationRequest({
      medication: medication1
    }));
    this.args.changeset.set('prescriptions', treatments1);
  }
  ignoreTreatment(code1, event1) {
    event1.preventDefault();
    const ignoredAtcCodes1 = this.args.changeset.get('ignoredAtcCodes') ? [...this.args.changeset.get('ignoredAtcCodes')] : [];
    ignoredAtcCodes1.push(code1);
    this.args.changeset.set('ignoredAtcCodes', ignoredAtcCodes1);
  }
  alreadyHadTreatment(code1, treatmentPrescriptionChangedJournalEvents1) {
    return treatmentPrescriptionChangedJournalEvents1?.some(treatmentPrescriptionChangedJournalEvent1 => treatmentPrescriptionChangedJournalEvent1.atcCodes.includes(code1));
  }
  get codes() {
    const existingTreatments1 = this.args.changeset.get('prescriptions');
    const existingIgnoredTreatments1 = this.args.changeset.get('ignoredAtcCodes');
    /**
    * Filter the suggestions if some have already been ignored
    * or added to the treatments list
    */
    return this.args.codes.reduce((acc1, curr1) => {
      if (existingTreatments1?.some(prescription1 => prescription1?.medication?.molecule?.code === curr1) || existingIgnoredTreatments1.includes(curr1) || this.alreadyHadTreatment(curr1, this.args.treatmentPrescriptionChangedJournalEvents)) {
        return acc1;
      }
      acc1.push(curr1);
      return acc1;
    }, []);
  }
}, setComponentTemplate(precompileTemplate("\n    {{#if this.codes.length}}\n      <div class=\"ui message\">\n        <span>Votre patient prend-il un des traitements ci-apr\xE8s ?</span>\n        <ul>\n          {{#each this.codes as |code|}}\n            <li class=\"[&:not(:first-child)>div:first]:pt-2\">\n              <div class=\"grid grid-cols-[1.5fr_0.5fr_0.5fr_1fr] [.ui.message_li:not(:first-child)_&]:pt-[0.5em]\">\n                <span class=\"mr16\">{{t (concat \"atc.\" code)}}</span>\n                <button class=\"ui mini primary button mr16 px-4 py-2\" type=\"button\" data-test-add-button={{code}} {{on \"click\" (fn this.addTreatment code)}}>\n                  Oui\n                </button>\n                <button class=\"ui mini primary button mr16 px-4 py-2\" type=\"button\" data-test-ignore-button={{code}} {{on \"click\" (fn this.ignoreTreatment code)}}>\n                  Non\n                </button>\n              </div>\n            </li>\n          {{/each}}\n        </ul>\n      </div>\n    {{/if}}\n  ", {
  strictMode: true,
  scope: () => ({
    t,
    concat,
    on,
    fn
  })
}), _TreatmentsSection), _TreatmentsSection), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addTreatment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addTreatment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ignoreTreatment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "ignoreTreatment"), _class.prototype), _class);
export { TreatmentsSection as default };